const integrationRoutes = [
  {
    path: "/integrations/melhor-envio",
    name: "integrations.melhor-envio.settings",
    component: () =>
      import("@/modules/integration/views/MelhorEnvioSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Melhor Envio — Configurações",
      roles: [1, 5]
    }
  },
  {
    path: "/integrations/construshow",
    name: "integrations.construshow.settings",
    component: () =>
      import("@/modules/integration/views/ConstrushowSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Construshow — Configurações",
      roles: [1, 5]
    }
  }
];

export default integrationRoutes;
